import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';
import { borderColor, header, titles } from '../../../../styles/colors';
import { BreakPoints } from '../../../../styles/styles';

const { spacing } = THEME;

export const contactTable = {
	connection: {
		flexGrow: 1,
		margin: '0 10px',
		width: 140,
		[BreakPoints.forMaxWidth(1080)]: {
			display: 'none',
		},
	},
	domain: {
		flexGrow: 1,
		margin: '0 10px',
		width: 140,
		[BreakPoints.forMaxWidth(1080)]: {
			display: 'none',
		},
	},
	name: {
		flexGrow: 1,
		margin: '0 10px 0 20px',
		width: 160,
	},
	selection: {
		alignItems: 'center',
		display: 'flex',
		height: 50,
		justifyContent: 'center',
		paddingLeft: 12,
		width: 50,
	},
	tags: {
		flexGrow: 1,
		margin: '0 10px',
		width: 140,
	},
};

export const styleSheet = StyleSheet.create({
	databoardBody: {
		justifyContent: `flex-start`,
	},
	avatar: {
		width: 50,
	},
	connections: {
		...contactTable.connection,
	},
	databoard: {
		flex: 1,
		minHeight: 0,
		marginBottom: spacing.md,
	},
	domain: {
		...contactTable.domain,
	},
	name: {
		...contactTable.name,
	},
	placeholder: {
		marginTop: 60,
	},
	selectAll: {
		paddingLeft: 28,
		width: 60,
	},
	selectAllText: {
		fontSize: 12,
	},
	sortIcon: {
		marginLeft: 6,
	},
	sortIconFlipped: {
		transform: 'rotate3d(0,0,1, 180deg)',
	},
	sortMenu: {
		backgroundColor: 'white',
		border: `1px solid ${borderColor}`,
		borderRadius: 8,
		boxShadow: `0px 2px 4px 0px ${borderColor}`,
		color: titles,
		fontSize: 14,
		width: 180,
		padding: 0,
		overflow: 'hidden',
	},
	sortMenuItem: {
		':hover': {
			backgroundColor: borderColor,
			cursor: 'pointer',
		},
		':not(:last-child)': {
			borderBottom: '1px solid #f0eded',
		},
		color: header,
		cursor: 'pointer',
		padding: '8px 12px',
		border: 'none',
		background: 'none',
		width: '100%',
		textAlign: 'left',
		fontSize: 14,
	},
	sortTrigger: {
		alignItems: 'center',
		cursor: 'pointer',
		display: 'flex',
		fontSize: 12,
		gap: 4,
		textTransform: 'uppercase',
	},
	tableBodyHappiness: {
		flex: 1,
		minHeight: 0,
	},
	tags: {
		...contactTable.tags,
	},
	visibility: {
		alignItems: 'center',
		display: 'flex',
		margin: '0 15px',
		width: 15,
	},
});
